export enum OrganizationCode {
  /**
   * An organization that provides healthcare services.
   */
  HealthcareProvider = 'prov',
  /**
   * A department or ward within a hospital (Generally is not applicable to top level organizations)
   */
  HospitalDepartment = 'dept',
  /**
   * An organizational team is usually a grouping of practitioners that perform a specific
   * function within an organization (which could be a top level organization, or a department).
   * */
  OrganizationalTeam = 'team',
  /**
   * A company that provides insurance to its subscribers that
   * may include healthcare related policies.
   */
  InsuranceCompany = 'ins',
  /**
   * Other type of organization not already specified.
   */
  Other = 'other',
  /**
   * An organization that prepares and dispense medication.
   */
  PharmacyProvider = 'pharmacy',
}

export const OrganizationCodeDescription: Record<OrganizationCode, string> = {
  [OrganizationCode.HealthcareProvider]: 'Healthcare Provider',
  [OrganizationCode.HospitalDepartment]: 'Hospital Department',
  [OrganizationCode.OrganizationalTeam]: 'Organizational Team',
  [OrganizationCode.InsuranceCompany]: 'Insurance Company',
  [OrganizationCode.Other]: 'Other',
  [OrganizationCode.PharmacyProvider]: 'Pharmacy',
};
